/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion, parseDateTime } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LandingSummaryDto as FeatureLandingSummaryDto } from '../../models/feature/landing-summary-dto';

export interface GetLandingSummary$Params {
}

export function getLandingSummary(http: HttpClient, rootUrl: string, params?: GetLandingSummary$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureLandingSummaryDto>> {
  const rb = new RequestBuilder(rootUrl, getLandingSummary.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r.clone({ body: reviveResponseBody(r.body) }) as StrictHttpResponse<FeatureLandingSummaryDto>;
    })
  );
}

getLandingSummary.PATH = '/landing/summary';

function reviveFeatureLandingSummaryDto(value: any): any {
  if (value) {
    if (value["personal"] != null) {
      value["personal"] = reviveFeaturePersonalDataDto(value["personal"]);
    }
    if (value["tenant"] != null) {
      value["tenant"] = reviveFeatureTenantDataDto(value["tenant"]);
    }
  }
  return value;
}

function reviveFeaturePersonalDataDto(value: any): any {
  if (value) {
    if (value["currentMembership"]) {
      for (let i0 = 0; i0 < value["currentMembership"].length; i0++) {
        if (value["currentMembership"][i0] != null) {
          value["currentMembership"][i0] = reviveFeatureMembershipDto(value["currentMembership"][i0]);
        }
      }
    }
    if (value["lastInvoice"] != null) {
      value["lastInvoice"] = reviveFeatureInvoiceDto(value["lastInvoice"]);
    }
    if (value["unpaidInvoices"]) {
      for (let i0 = 0; i0 < value["unpaidInvoices"].length; i0++) {
        if (value["unpaidInvoices"][i0] != null) {
          value["unpaidInvoices"][i0] = reviveFeatureInvoiceDto(value["unpaidInvoices"][i0]);
        }
      }
    }
    if (value["loanedAssets"]) {
      for (let i0 = 0; i0 < value["loanedAssets"].length; i0++) {
        if (value["loanedAssets"][i0] != null) {
          value["loanedAssets"][i0] = reviveFeatureLoanedAssetDto(value["loanedAssets"][i0]);
        }
      }
    }
  }
  return value;
}

function reviveFeatureMembershipDto(value: any): any {
  if (value) {
    if (value["dateJoined"] != null) {
      value["dateJoined"] = parseDateTime(value["dateJoined"]);
    }
  }
  return value;
}

function reviveFeatureInvoiceDto(value: any): any {
  if (value) {
    if (value["earlyBirdDue"] != null) {
      value["earlyBirdDue"] = parseDateTime(value["earlyBirdDue"]);
    }
    if (value["due"] != null) {
      value["due"] = parseDateTime(value["due"]);
    }
    if (value["paid"] != null) {
      value["paid"] = parseDateTime(value["paid"]);
    }
  }
  return value;
}

function reviveFeatureLoanedAssetDto(value: any): any {
  if (value) {
    if (value["dateBorrowed"] != null) {
      value["dateBorrowed"] = parseDateTime(value["dateBorrowed"]);
    }
  }
  return value;
}

function reviveFeatureTenantDataDto(value: any): any {
  if (value) {
    if (value["details"] != null) {
      value["details"] = reviveFeatureTenantDetailsDto(value["details"]);
    }
    if (value["ensembleSummaries"]) {
      for (let i0 = 0; i0 < value["ensembleSummaries"].length; i0++) {
        if (value["ensembleSummaries"][i0] != null) {
          value["ensembleSummaries"][i0] = reviveFeatureEnsembleSummaryDto(value["ensembleSummaries"][i0]);
        }
      }
    }
    if (value["lastConcert"] != null) {
      value["lastConcert"] = reviveFeatureConcertDto(value["lastConcert"]);
    }
    if (value["latestBillingPeriods"]) {
      for (let i0 = 0; i0 < value["latestBillingPeriods"].length; i0++) {
        if (value["latestBillingPeriods"][i0] != null) {
          value["latestBillingPeriods"][i0] = reviveFeatureBillingPeriodDto(value["latestBillingPeriods"][i0]);
        }
      }
    }
  }
  return value;
}

function reviveFeatureTenantDetailsDto(value: any): any {
  if (value) {
    if (value["dateFounded"] != null) {
      value["dateFounded"] = parseDateTime(value["dateFounded"]);
    }
  }
  return value;
}

function reviveFeatureEnsembleSummaryDto(value: any): any {
  if (value) {
    if (value["firstConcertDate"] != null) {
      value["firstConcertDate"] = parseDateTime(value["firstConcertDate"]);
    }
  }
  return value;
}

function reviveFeatureConcertDto(value: any): any {
  if (value) {
    if (value["date"] != null) {
      value["date"] = parseDateTime(value["date"]);
    }
  }
  return value;
}

function reviveFeatureBillingPeriodDto(value: any): any {
  if (value) {
    if (value["earlyBirdDue"] != null) {
      value["earlyBirdDue"] = parseDateTime(value["earlyBirdDue"]);
    }
    if (value["due"] != null) {
      value["due"] = parseDateTime(value["due"]);
    }
  }
  return value;
}

function reviveResponseBody(body: any): any {
  if (body != null) {
    body = reviveFeatureLandingSummaryDto(body);
  }
  return body;
}
